/**
 * Meta JSON Flows route (`whatsappform` / Flow Builder).
 * Conversational chatbot graph is Automations → Chatbot AI (`chatbotai`).
 */
import Flows from "./Flows";

const WhatsappForm = () => <Flows visualBuilder />;

export default WhatsappForm;
